export default "__VITE_ASSET__C$1xLY5m__"